import { render, staticRenderFns } from "./cham-cong-nhan-su.vue?vue&type=template&id=1622701e"
import script from "./cham-cong-nhan-su.vue?vue&type=script&lang=js"
export * from "./cham-cong-nhan-su.vue?vue&type=script&lang=js"
import style0 from "./cham-cong-nhan-su.vue?vue&type=style&index=0&id=1622701e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports